export const utcToLocalDateTime = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleString();
};
